module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-honda.406e4659.png";